<template>
  <AuthFrame :title="t('auth.forgotTitle')" :lead="t('auth.forgotLead')">
    <form v-if="!sent" class="panel" @submit.prevent="submit">
      <label class="field">
        <span>{{ t('auth.email') }}</span>
        <input
          v-model="email"
          type="email"
          autocomplete="email"
          required
        />
      </label>
      <p v-if="errorKey" class="error">{{ t(errorKey) }}</p>
      <button type="submit" class="cta" :disabled="auth.busy">
        {{ t('auth.forgotSend') }}
      </button>
    </form>
    <p v-else class="panel sent">{{ t('auth.forgotSent') }}</p>
    <template #footer>
      <p class="switch">
        <router-link :to="{ name: 'login' }">{{ t('auth.goLogin') }}</router-link>
      </p>
    </template>
  </AuthFrame>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import AuthFrame from '../components/AuthFrame.vue'
import { useI18n } from '../i18n/t'
import { ApiError } from '../api/http'
import { useAuthStore } from '../stores/auth'

const { t } = useI18n()
const auth = useAuthStore()
const email = ref('')
const sent = ref(false)
const errorKey = ref('')

function errorToKey(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.code === 'forgot_limited') return 'auth.errors.forgot_limited'
    if (err.code === 'rate_limited') return 'auth.errors.rate_limited'
    if (err.code === 'validation') return 'auth.errors.validation'
    if (
      err.code === 'database_unavailable' ||
      err.code === 'forgot_failed' ||
      err.status === 503
    ) {
      return 'auth.errors.database_unavailable'
    }
  }
  return 'auth.errors.network'
}

async function submit(): Promise<void> {
  errorKey.value = ''
  try {
    await auth.requestPasswordReset(email.value)
    sent.value = true
  } catch (err) {
    errorKey.value = errorToKey(err)
  }
}
</script>

<style scoped>
.sent {
  margin: 0;
  color: var(--md-sys-color-on-surface);
  font-size: 14px;
  line-height: 20px;
}
</style>
